import {Component} from '@angular/core';
import {RouterLink, RouterOutlet} from "@angular/router";
import {NzMenuDirective, NzMenuItemComponent} from "ng-zorro-antd/menu";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  standalone: true,
  imports: [
    RouterOutlet,
    NzMenuDirective,
    NzMenuItemComponent,
    RouterLink
  ],
  styleUrl: './home.component.less'
})
export class HomeComponent {
}
